export default function UserMenuOptions(
  userType,
  { sharedBrandSession = false } = {},
) {
  const type = String(userType || "").toLowerCase();
  const changePassword = {
    id: "password",
    buttonName: "Change password",
    buttonAction: "./account/password",
  };
  const yourCollection = {
    id: "collection",
    buttonName: "Your Collection",
    buttonAction: "./collection",
  };
  const collection = {
    id: "collection",
    buttonName: "Collection",
    buttonAction: "./collection",
  };
  const library = {
    id: "library",
    buttonName: "Library",
    buttonAction: "./library",
  };
  const addEdit = {
    id: "add-edit",
    buttonName: "Add/Edit Materials",
    buttonAction: "./material/add",
  };
  const feedback = {
    id: "feedback",
    buttonName: "Feedback",
    buttonAction: "./contact",
  };
  const support = {
    id: "help",
    buttonName: "Support",
    buttonAction: "./help",
  };

  if (type === "vendoradmin") {
    return [
      yourCollection,
      library,
      addEdit,
      {
        id: "settings",
        buttonName: "Settings",
        buttonAction: "./settings",
      },
      feedback,
      support,
      changePassword,
    ];
  }

  if (type === "vendor") {
    return [
      yourCollection,
      library,
      addEdit,
      {
        id: "price",
        buttonName: "Price Update",
        buttonAction: "./material/price",
      },
      feedback,
      support,
      changePassword,
    ];
  }

  if (type === "designer") {
    const items = [
      collection,
      library,
      feedback,
      support,
    ];
    if (!sharedBrandSession) {
      items.push(changePassword);
    }
    return items;
  }

  if (type === "guest") {
    return [
      { id: "login", buttonName: "Login", buttonAction: "./" },
      feedback,
      support,
    ];
  }
}
